<template>
    <div class="mb-5">
        <div class="p-3 my-3 bg-light">
            <strong>インボイス情報</strong>
        </div>

        <span>インボイス番号（未入力は自動生成）</span>
        <b-form-input
            v-model="value.number"
            class="mb-3"
            />

        <span>発行日</span>
        <b-form-datepicker
            v-model="value.issued_at"
            size="md"
            class="mb-3"
            placeholder=""
            :start-weekday="1"
            :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit', weekday: 'narrow', }"
            close-button
            reset-button
            >
        </b-form-datepicker>

        <span>署名</span>
        <b-form-checkbox
            v-model="sync_signature"
            :value="true"
            :unchecked-value="false"
            class="float-right"
            >
            From担当者をコピー
        </b-form-checkbox>
        <b-form-input
            v-model="value.signature"
            @focus="sync_signature = false"
            class="mb-3"
            />
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import InputError from '@/components/InputError.vue'

export default {
    components: {
        InputError,
    },
    emits: [
        'save',
        'destroy',
    ],
    props: {
        value: {
            type: Object,
            required: true,
            default() {
                return {}
            },
        },
        init: {
            type: Function,
            default() {
                return null
            },
        },
        signature_default: {
            type: String,
            required: false,
            default: '',
        },
    },
    data() {
        return {
            timer: null,
            key: 0,

            sync_signature: true,

        }
    },
    computed: {
        ...mapGetters([
            'auth_uuid',
            'auth_level',
            'trans',
        ]),
    },
    watch: {
    },
    mounted() {
        this.timer = window.setInterval(this.interval, 1 * 1000)
    },
    destroyed() {
        clearInterval(this.timer)
    },
    methods: {
        interval () {
            if (this.sync_signature) {
                this.value.signature = this.signature_default
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.item-name {
    font-size: 1.6em;
    margin-bottom: 0;
}
.item-price {
    font-size: 1.6em;
    margin-bottom: 0;
}
.shipping-address-th {
    width:0.1%;
    white-space: nowrap;
}
</style>

